/**
 * TanStack Query hooks for `bulk-targeting` (FS-812).
 * Thin wrappers over ./api. All raw fetch lives in api.ts only.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	bulkTargetingQueryKeys,
	getJob,
	importCsv,
	listJobs,
	type ImportResult,
	type JobResponse,
} from "./api";

export function useBulkTargetingJobs(): UseQueryResult<JobResponse[], Error> {
	return useQuery({
		queryKey: bulkTargetingQueryKeys.list(),
		queryFn: listJobs,
	});
}

export function useBulkTargetingJob(
	jobId: string | null,
): UseQueryResult<JobResponse, Error> {
	return useQuery({
		queryKey: bulkTargetingQueryKeys.detail(jobId ?? "none"),
		queryFn: () => getJob(jobId as string),
		enabled: !!jobId,
	});
}

export function useBulkTargetingImport(): UseMutationResult<
	ImportResult,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (csvText: string) => importCsv(csvText),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: bulkTargetingQueryKeys.all });
		},
	});
}
